export enum ButtonColour {
  BLUE, RED, GREEN
}
